import React, { useEffect, useState } from 'react';
import SafeCredsGrid from './safeCredsGrid';
import AddCredentialModal from './addNew';

import {
  getCredentialsList,
  createCredential,
  updateCredential,
  deleteCredential,
} from 'service/credsManagement';

import {
  containerStyle,
  headerRowStyle,
  titleStyle,
  addButtonStyle,
  addSymbolStyle,
} from './styles';

export default function CredentialManagement() {
  const [loading, setLoading] = useState(true);
  const [credentialList, setCredentialList] = useState<any[]>([]);
  const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
  const [openModal, setOpenModal] = useState(false);
  const [editData, setEditData] = useState<any>(null);

  // Fetch credentials
  const loadData = async (query: Record<string, any> = {}) => {
    setLoading(true);

    const list = await getCredentialsList(query);

    const activeRecords = (list || [])
      .filter((item: any) => item.status === 'Active')
      .map((item: any) => ({
        ...item,
        id: item._id,
      }));

    setCredentialList(activeRecords);
    setLoading(false);
  };

  const handleSort = async (sortInfo: { sortBy: string; sortDir: string }) => {
    setSortingInfo(sortInfo);
    const query: Record<string, any> = {};

    if (sortInfo.sortBy) {
      query.sortBy = sortInfo.sortBy;
      query.orderBy = sortInfo.sortDir;
      query.sortDir = sortInfo.sortDir;
      query.sortOrder = sortInfo.sortDir;
    }

    await loadData(query);
  };

  useEffect(() => {
    loadData();
  }, []);

  // Save handler
  const handleSave = async (payload: any) => {
    try {
      if (editData) {
        await updateCredential(editData._id, payload);
      } else {
        await createCredential(payload);
      }

      setOpenModal(false);
      setEditData(null);
      loadData();
    } catch (err) {
      console.error('Save error:', err);
    }
  };

  // Delete handler
  const handleDelete = async (row: any) => {
    try {
      await deleteCredential(row._id);
      loadData();
    } catch (err) {
      console.error('Delete error:', err);
    }
  };

  return (
    <div style={containerStyle}>
      {/* HEADER */}
      <div style={headerRowStyle}>
        <h2 style={titleStyle}>Credentials</h2>

        <button
          onClick={() => {
            setEditData(null);
            setOpenModal(true);
          }}
          style={addButtonStyle}
        >
          <span style={addSymbolStyle}>+</span> Add New
        </button>
      </div>

      {/* GRID TABLE */}
      <SafeCredsGrid
        data={credentialList}
        loading={loading}
        onEdit={(row: any) => {
          setEditData(row);
          setOpenModal(true);
        }}
        onDelete={handleDelete}
        onSort={handleSort}
        sortingInfo={sortingInfo}
      />

      {/* MODAL: ADD / EDIT */}
      {openModal && (
        <AddCredentialModal
          open={openModal}
          onClose={() => {
            setOpenModal(false);
            setEditData(null);
          }}
          onSave={handleSave}
          editData={editData}
        />
      )}
    </div>
  );
}
